type ConsoleMethod = "log" | "info" | "debug" | "warn";

const NOISY_PATTERNS = [
  /\[Violation\]/i,
  /Search endpoint requested/i,
  /^Navigated to /i,
  /back\/forward cache/i,
];

const hasVerboseFlag = () => {
  if (typeof window === "undefined") return false;

  const params = new URLSearchParams(window.location.search);
  if (params.get("debug") === "true" || params.get("verboseLogs") === "true") {
    return true;
  }

  try {
    return localStorage.getItem("enableVerboseLogs") === "true";
  } catch {
    return false;
  }
};

/**
 * Suppress noisy runtime logs in production builds while keeping critical errors.
 * Useful for hiding Chrome "[Violation]" messages and third-party iframe chatter.
 */
export function suppressConsoleNoise(options?: { allowVerbose?: boolean }) {
  if (!import.meta.env.PROD) return;

  const allowVerbose = options?.allowVerbose || hasVerboseFlag();

  const wrap = (method: ConsoleMethod, dropVerbose: boolean) => {
    const original = console[method]?.bind(console);
    console[method] = (...args: any[]) => {
      const firstArg = args[0];
      const text = typeof firstArg === "string" ? firstArg : "";

      if (text && NOISY_PATTERNS.some((pattern) => pattern.test(text))) {
        return;
      }

      if (dropVerbose && !allowVerbose) {
        return;
      }

      original?.(...args);
    };
  };

  // Silence verbose logs by default, but keep errors untouched.
  wrap("log", true);
  wrap("info", true);
  wrap("debug", true);
  // Filter known noisy warnings but let genuine warnings through.
  wrap("warn", false);
}
